/**
 * Error codes for FetchTransformer operations
 * Used to identify specific error types in transformer error handling
 */
export const FETCH_TRANSFORMER_ERROR_CODE = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  AUTH_ERROR: 'AUTH_ERROR',
  HTTP_ERROR: 'HTTP_ERROR',
  PSI_ERROR: 'PSI_ERROR',
  INVALID_PARAMETER_ERROR: 'INVALID_PARAMETER_ERROR',
  TOKEN_REFRESH_ERROR: 'TOKEN_REFRESH_ERROR',
} as const;

/**
 * Fallback error code for thrown values that are not ServiceErrors
 */
export const UNKNOWN_ERROR_CODE = 'UNKNOWN_ERROR';
